import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const uploadFile = createAsyncThunk(
  'file/upload',
  async (reqBody: any, { rejectWithValue }) => {
    // console.log(reqBody)
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(API_ENDPOINTS.fileUpload, reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      // console.log(error);
      return rejectWithValue(error.response.data.message);
    }
  }
);